/**
 * A function that maps all API error responses to inputs using RHF `setError`
 * @param setError RHF set error function passed in as a callback
 * @param errors Errors object returned from the API
 */
export function setFormErrors(setError, errors: Record<string, string>) {
  for (const error in errors) {
    setError(error, {
      type: 'server',
      message: errors[error]
    });
  }
}
